import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import { PageTitle } from "@/components/PageTitle";
import { About, Contact, Terms, Privacy } from "@/pages/Legal";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Practitioners from "@/pages/Practitioners";
import PractitionerDetail from "@/pages/PractitionerDetail";
import Membership from "@/pages/Membership";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Resources from "@/pages/Resources";
import Community from "@/pages/Community";
import Shop from "@/pages/Shop";
import CuddlerApply from "@/pages/CuddlerApply";
import Admin from "@/pages/Admin";
import Messages from "@/pages/Messages";
import PractitionerPortal from "@/pages/PractitionerPortal";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="py-24 text-center text-[#A89896]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-[#110D0D]">
          <PageTitle />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/practitioners" element={<Practitioners />} />
              <Route path="/practitioners/:id" element={<PractitionerDetail />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/community" element={<Community />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/apply" element={<CuddlerApply />} />
              <Route path="/practitioner" element={<Protected><PractitionerPortal /></Protected>} />
              <Route path="/messages" element={<Protected><Messages /></Protected>} />
              <Route path="/admin" element={<Protected><Admin /></Protected>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
